import { render, staticRenderFns } from "./CurriculumFormPage.vue?vue&type=template&id=218c1b22&scoped=true"
import script from "./CurriculumFormPage.vue?vue&type=script&lang=js"
export * from "./CurriculumFormPage.vue?vue&type=script&lang=js"
import style0 from "./CurriculumFormPage.vue?vue&type=style&index=0&id=218c1b22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218c1b22",
  null
  
)

export default component.exports